import { Cache } from 'aws-amplify'

export enum PagePriority {
  account = 0,
  signup = 5,
  content = 10
}
/**
 * Set the page priority state in cache.
 *
 * Priorities:
 * - account: 0
 * - signup: 5
 * - content page: 10
 *
 * @param {string} page - Page user is on. Can be PagePriority - 'content', 'signup' or 'account'.
 * @param {boolean} spoofMode - Do not set priority state in spoof.
 */
export const setPagePriorityState = (page: string, spoofMode: boolean) => {
  const pagePriorityCache = Cache.getItem('pagePriority') ?? null
  const pageKey = page.trim().toLowerCase() as keyof typeof PagePriority

  if (!(pageKey in PagePriority)) {
    console.error('Invalid page:', page)
    return
  }

  const updatedPriorityState = PagePriority[pageKey]

  if (updatedPriorityState === undefined) {
    console.error('Invalid page:', page)
    return
  }

  // Update if value lower
  if (!spoofMode && (pagePriorityCache === null || updatedPriorityState < pagePriorityCache)) {
    Cache.setItem('pagePriority', updatedPriorityState)
  }
}

/**
 * Return the page priority state from cache.
 *
 * @param {boolean} spoofMode - Do not set priority state in spoof.
 */
export const getPagePriorityState = (spoofMode: boolean) => {
  const pagePriorityCache = Cache.getItem('pagePriority')
  if (!spoofMode && pagePriorityCache !== undefined) {
    return pagePriorityCache
  }
}
